import { Icon } from "@climatepartner/components/Icon";
import { Box, Link, Stack } from "@mui/material";
import { ReactElement, ReactNode } from "react";

// Figma 1331-36352: this public header's colors are hardcoded to the design spec rather than
// theme tokens. Those resolve through the same generateCpTheme() the authenticated in-app pages
// use, so relying on them here would silently drift if that internal, app-tuned theme ever
// changes; these public pages need the exact design colors regardless.
const HEADER_BG = "#232221";
const HEADER_TEXT = "#ffffff";
const LEARN_MORE_TEXT = "#f1efe5";
const LEARN_MORE_BORDER = "#b0ad97";
const CONTACT_BG = "#dfcc59";
const CONTACT_TEXT = "#232221";

export const PageChrome = ({ children }: { children: ReactNode }): ReactElement => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      px: { xs: 2, md: 10 },
      pt: 2.5,
      backgroundImage: "url(/assets/login-background.avif)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}
  >
    <Stack
      data-testid="page-header"
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: HEADER_BG,
        color: HEADER_TEXT,
        borderRadius: 1,
        height: 48,
        pl: 5,
        pr: 0,
      }}
    >
      <Icon name="cpLogoFull" viewBox="0 0 170 23" sx={{ width: "170px", height: "100%" }} />
      <Stack direction="row" sx={{ height: "100%" }}>
        <Link
          href="https://www.climatepartner.com"
          target="_blank"
          rel="noopener"
          underline="none"
          sx={{
            display: "flex",
            alignItems: "center",
            pl: "33px",
            pr: "32px",
            borderLeft: `1px solid ${LEARN_MORE_BORDER}`,
            color: LEARN_MORE_TEXT,
          }}
        >
          Learn more
        </Link>
        <Link
          href="https://www.climatepartner.com/en/contact"
          target="_blank"
          rel="noopener"
          underline="none"
          sx={{
            display: "flex",
            alignItems: "center",
            px: 4,
            bgcolor: CONTACT_BG,
            color: CONTACT_TEXT,
          }}
        >
          Contact
        </Link>
      </Stack>
    </Stack>
    <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", py: 6 }}>{children}</Box>
  </Box>
);
